import { ActionMenuItem } from '@frontapp/ui-kit';

type Props = {
  title: string;
  url: string;
};

export default function GotoActionMenuItem({ title, url }: Props) {
  return (
    <ActionMenuItem
      iconName="ChevronRight"
      onClick={(e) => {
        e.stopPropagation();
      }}
      url={url}
    >
      {title}
    </ActionMenuItem>
  );
}

GotoActionMenuItem.displayName = 'Custom';
